// extracted by mini-css-extract-plugin
export default {"labeledSection":"calendarSettings_labeledSection__O-B88","labeledSectionSm":"calendarSettings_labeledSectionSm__WE8P9","tableRowCell":"calendarSettings_tableRowCell__BlfzO"};